<template>
<div class="subheader py-2 py-lg-12 subheader-transparent" v-bind:class="subheaderClasses" id="kt_subheader">
    <div class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap" v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }">
        <div v-if="account!=null" class="d-flex align-items-center">
            <el-image shape="square" style="width: 50px; height: 50px" :src="account.ins_logo" :fit="'contain'" class="mr-3 border bg-white rounded"></el-image>
            <div class="d-flex flex-column">
                <h2 class="text-white font-weight-bold mb-1 mr-5">
                    {{ account.ins_name }}
                </h2>
                <span class="text-white text-hover-white opacity-75 hover-opacity-100">
                    Representante: {{ account.repman }}
                </span>
            </div>
        </div>
        <div v-else class="d-flex align-items-center">
            <div class="d-flex flex-column">
                <h2 class="text-white font-weight-bold mb-1 mr-5">No se tiene información</h2>
                <span class="text-white text-hover-white opacity-75 hover-opacity-100">
                    Representante: No se tiene información
                </span>
            </div>
        </div>
        <div class="d-flex align-items-center mt-2">
            <router-link class="btn btn-transparent-white font-weight-bold py-3 px-6 mr-2" :to="'/dashboard'">
                <i class="el-icon-arrow-left"></i> volver
            </router-link>
            <button @click="onLogout" class="btn btn-transparent-white font-weight-bold py-3 px-6">
                Cerrar sesión
            </button>
        </div>
    </div>
</div>
</template>

<style lang="scss">
.custom-v-dropdown {
    &.dropdown-toggle {
        padding: 0;

        &:hover {
            text-decoration: none;
        }

        &.dropdown-toggle-no-caret {
            &:after {
                content: none;
            }
        }
    }

    &.dropdown-menu {
        margin: 0;

        .b-dropdown-text {
            padding: 0;
        }
    }
}
</style>

<script>
import {
    mapGetters
} from "vuex";
import {
    LOGOUT
} from "@/store/auth.module";

export default {
    name: "KTSubheader",
    props: {
        account: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        ...mapGetters(["layoutConfig"]),
        widthFluid() {
            return this.layoutConfig("subheader.width") === "fluid";
        },

        subheaderClasses() {
            const classes = [];
            const style = this.layoutConfig("subheader.style");
            if (style) {
                classes.push(style);

                if (style === "solid") {
                    classes.push("bg-white");
                }

                if (this.layoutConfig("subheader.fixed")) {
                    classes.push("border-top");
                }
            }
            return classes.join(" ");
        }
    },
    methods: {
        onLogout() {
            this.$store
                .dispatch(LOGOUT)
                .then(() => this.$router.push({
                    name: "login"
                }));
        }
    }
};
</script>
